import Checkbox from 'antd/lib/checkbox';

interface IExpandRowsCheckboxProps {
    totalRows: number;
    expandedRowKeys: React.Key[];
    handleExpandAll: () => void;
    handleCollapseAll: () => void;
}

export const ExpandRowsCheckbox: React.FC<IExpandRowsCheckboxProps> = ({ totalRows, expandedRowKeys, handleExpandAll, handleCollapseAll }) => {
    const allExpanded = expandedRowKeys.length === totalRows && totalRows > 0;
    const partiallyExpanded = expandedRowKeys.length > 0 && expandedRowKeys.length < totalRows;

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
                indeterminate={partiallyExpanded}
                checked={allExpanded}
                onChange={e => (e.target.checked ? handleExpandAll() : handleCollapseAll())}
            >
                Expand Rows
            </Checkbox>
        </div>
    );
};
